import { Flex, Text, useDisclosure, useOutsideClick } from '@chakra-ui/react';
import React, { useRef } from 'react';
import * as styles from './SortBy.module.scss';
import sortValues from './SortByData.json';
import { isMadPawsStore } from '../../../common/util';

const SortBy = ({ sortBy, selectHandler }) => {
  const { isOpen, onClose, onToggle } = useDisclosure(false);
  const sortRef = useRef();

  useOutsideClick({
    ref: sortRef,
    handler: onClose
  });

  return (
    <div className={styles.root} ref={sortRef}>
      <Flex
        align={'center'}
        gap={0}
        border={`1px solid ${isMadPawsStore() ? 'var(--primary-default)' : '#C9D5DA'}`}
        py={'10px'}
        px={4}
        className={'display'}
        role="button"
        onClick={onToggle}
        fontSize={14}
      >
        <svg
          width="14"
          height="10"
          viewBox="0 0 14 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.00052 1L5.13385 3.66667M3.00052 1L0.867188 3.66667M3.00052 1V9.33333"
            stroke={isMadPawsStore() ? 'var(--primary-default)' : '#006E95'}
            strokeWidth="1.2"
          />
          <path
            d="M11.0005 9.00008L13.1339 6.33342M11.0005 9.00008L8.86719 6.33342M11.0005 9.00008V0.666748"
            stroke={isMadPawsStore() ? 'var(--primary-default)' : '#006E95'}
            strokeWidth="1.2"
          />
        </svg>
        <Text ml={'12px'} mr={'16px'} fontSize={14} fontWeight={500}>
          {sortBy ? sortValues.find(value => value.value === sortBy)?.label : 'Sort By'}
        </Text>
        <svg
          width="12"
          height="8"
          viewBox="0 0 12 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M11.2008 1L6.00078 6.6L0.800781 1" stroke={isMadPawsStore() ? 'var(--primary-default)' : '#7A8591'} strokeLinecap="square" />
        </svg>
      </Flex>
      <ul className={`${isOpen ? 'active' : ''}`}>
        {sortValues &&
          sortValues.map((item, index) => (
            <li
              key={index}
              onClick={() => {
                selectHandler(item.value);
                onClose();
              }}
              role="presentation"
            >
              {item.label}
            </li>
          ))}
      </ul>
    </div>
  );
};

export default SortBy;
